module.exports = __webpack_public_path__ + "img/water_des_3.a88df540.jpg";